export default class ProgressService {
  store = null

  constructor(store) {
    this.store = store
  }

  has(progress) {
    return this.store.getters['pointsImporterProgress/progress'][progress] !== undefined
  }

  get(type) {
    return this.store.getters['pointsImporterProgress/progress'][type]
  }

  all() {
    return this.store.getters['pointsImporterProgress/progress']
  }

  set(type, progress) {
    if (!this.has(type)) {
      throw new Error(`Progress ${type} does not exist`)
    }
    this.store.dispatch('pointsImporterProgress/setProgress', { type, progress})
  }

  start(type) {
    this.set(type, 0)
  }

  reset(type) {
    this.store.dispatch('pointsImporterProgress/resetProgress', type)
  }
}
